<template>
  <div class="leftBox">
    <el-card class="top-card">
      <div class="top">
        <el-avatar :size="120" :src="avatarImg"></el-avatar>
        <div class="info">
          <div>
            <div class="active">用户编号</div>
            <div>{{ baseInfo.userNum }}</div>
          </div>
          <div>
            <div class="active">用电地址</div>
            <div>{{ baseInfo.userAddr }}</div>
          </div>
        </div>
      </div>
      <div class="bottom-btn">
        <el-button @click="toHistory" class="btn">历史数据</el-button>
      </div>
    </el-card>

    <el-card class="bottom-card">
      <div class="center">
        <div class="word">
          <FirstHeading>用电明细</FirstHeading>
          <div class="selectInfo">
            <el-date-picker
              @change="changeDateEv"
              :picker-options="pickerOptions"
              v-model="dateDay"
              type="date"
              style="width: 336px"
              format="yyyy-MM-dd"
              v-show="dateType == 'day'"
              placeholder="选择日期">
            </el-date-picker>

            <el-date-picker
              v-model="dateMonth"
              @change="changeDateEv"
              :picker-options="pickerMonth"
              v-show="dateType == 'month'"
              style="width: 336px"
              size="small"
              key="monthPicker"
              type="monthrange"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
            </el-date-picker>
            <div class="year-range-picker" v-show="dateType == 'year'">
              <el-date-picker
                @change="changeStartYear"
                :picker-options="pickerOptions"
                v-model="dateYear"
                style="width: 130px"
                size="small"
                type="year"
                format="yyyy"
                value-format="yyyy"
                key="yearPicker"
                placeholder="选择年">
              </el-date-picker>
              <span class="range-word"> 至 </span>
              <el-date-picker
                @change="changeEndYear"
                :picker-options="pickerOptions"
                v-model="dateYearEnd"
                style="width: 130px"
                size="small"
                key="yearPickers"
                type="year"
                format="yyyy"
                value-format="yyyy"
                placeholder="选择年">
              </el-date-picker>
            </div>

            <div class="btnGroup">
              <el-button
                :class="[{ active: dateType === 'day' }, 'btn']"
                @click="handleClick('day')"
                >日</el-button
              >
              <el-button
                :class="[{ active: dateType === 'month' }, 'btn']"
                @click="handleClick('month')"
                >月</el-button
              >
              <el-button
                :class="[{ active: dateType === 'year' }, 'btn']"
                @click="handleClick('year')"
                >年</el-button
              >
            </div>
          </div>
        </div>
        <LineChart
          class="chart"
          :width="chartInfo.width"
          :height="chartInfo.height"
          :options="chartInfo.options" />
      </div>
    </el-card>
  </div>
</template>

<script>
import LineChart from "@/components/echarts/lineChart.vue";
import FirstHeading from "@/components/firstHeading.vue";

import {
  monthElecLine,
  monthElecTable,
  userBaseInfo,
  getPowerInformationApi,
} from "@/api/powerInformation.js";
import { formatterDate, addDate, addMonth } from "@/utils/utils.js";

export default {
  name: "",
  components: { LineChart, FirstHeading },
  data() {
    return {
      userNum: "",
      roleId: "",
      baseInfo: {},
      chartInfo: {
        width: "100%",
        height: "85%",
        options: {
          // toolbox: {
          //   itemSize: 13,
          //   feature: {
          //     dataZoom: {
          //       yAxisIndex: "none",
          //     },
          //     restore: {},
          //   },
          // },

          dataZoom: [
            {
              type: "inside",
              throttle: 50,
            },
          ],
          tooltip: {
            trigger: "axis",
          },
          legend: {},
          dataset: {
            // 自定义数据维度
            dimensions: ["electric", "upDate"],
            source: [], // 数据源，可以动态赋值
          },
          xAxis: {
            // type: "time",
            type: "category",
            // name: "时间",
            boundaryGap: false,
          },
          yAxis: {
            name: "单位:kWh",
            type: "value",
            splitLine: {
              show: true, // 不显示网格线
            },
            axisPointer: {
              snap: true,
            },
          },
          // visualMap: {
          //   show: true,
          //   dimension: 1,
          //   seriesIndex: 0,
          //   pieces: [
          //     {
          //       lte: 32,
          //       color: "#DF2626",
          //     },
          //     {
          //       gt: 32,
          //       lte: 68,
          //       color: "#D59035",
          //     },
          //     {
          //       gt: 68,

          //       color: "#16BC7C",
          //     },
          //   ],
          // },
          series: [
            {
              type: "line",
              smooth: true,
              encode: {
                x: "upDate",
                y: "electricp",
                tooltip: ["electric"],
              },
            },
          ],
        },
      },
      isUser: false,
      avatarImg: require("@/assets/icons/user.png"),
      tableData: [],
      dateType: "day",
      monthList: [
        { value: 1, label: "1月" },
        { value: 2, label: "2月" },
        { value: 3, label: "3月" },
        { value: 4, label: "4月" },
        { value: 5, label: "5月" },
        { value: 6, label: "6月" },
        { value: 7, label: "7月" },
        { value: 8, label: "8月" },
        { value: 9, label: "9月" },
        { value: 10, label: "10月" },
        { value: 11, label: "11月" },
        { value: 12, label: "12月" },
      ],
      dateDay: formatterDate(new Date()),
      dateMonth: [
        formatterDate(new Date(), "month"),
        addMonth(new Date(), "month"),
      ],
      dateYear: "2023",
      dateYearEnd: "2024",
      startDate: "",
      endDate: "",
      monthValue: new Date().getMonth() + 1,
      pickerOptions: {
        disabledDate(time) {
          // 禁用以后的时间
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      pickerMonth: {
        disabledDate(time) {
          // time = addMonth(time);
          let t = new Date().getDate();
          // 禁用以后的时间
          return time.getTime() > Date.now() + 8.64e7 * t;
        },
      },
    };
  },
  created() {
    const roleId = sessionStorage.getItem("role");
    if (roleId === "4") {
      this.userNum = sessionStorage.getItem("userNum");
      this.roleId = sessionStorage.getItem("role");
    } else {
      this.userNum = this.$route.query.routeQuery;
      this.roleId = this.$route.query.roleId;
    }

    this.getBaseInfo();
    // this.getlineData();
    this.getChartDataEv();
    // this.getTableData();
  },
  methods: {
    toHistory() {
      this.jumpFn("/powerinformation/zhuanqueryhistory", {
        routeQuery: this.userNum,
      });
    },
    handleClick(dateType) {
      this.dateType = dateType;
      this.changeDateEv();
      // this.getChartDataEv();
    },
    async getlineData() {
      const query = {
        roleId: this.roleId,
        userNum: this.userNum,
      };
      const res = await monthElecLine(query);

      if (res.code === 200) {
        this.chartInfo.options.dataset.source = res.data;
      }
    },
    async getTableData() {
      const query = {
        roleId: this.roleId,
        userNum: this.userNum,
      };
      const res = await monthElecTable(query);

      if (res.code === 200) {
        this.tableData = res.data.electricMonthInformationVO;
      }
    },
    async getBaseInfo() {
      const res = await userBaseInfo({ userNum: this.userNum });
      if (res.code === 200) {
        this.baseInfo = res.data;
      }
    },
    getChartDataEv() {
      let params = {
        type:
          this.dateType == "day"
            ? 1
            : this.dateType == "month"
            ? 2
            : this.dateType == "year"
            ? 3
            : 1,
        startDate: this.startDate,
        endDate: this.endDate,
      };

      getPowerInformationApi(params).then((res) => {
        if (res.code === 200) {
          let data = res.data;
          let newArray = [];

          // newArray = data.date.map((date, index) => ({
          //   upDate: date,
          //   electric: data.electric[index],
          // }));

          if (this.dateType == "day") {
            newArray = data.date.map((date, index) => ({
              upDate: date,
              electric: data.electric[index],
            }));
          } else {
            newArray = data.date.map((date, index) => ({
              upDate: date,
              electric: data.P[index],
            }));
          }

          //
          this.chartInfo.options.dataset.source = newArray;
        }
      });
    },

    changeDateEv(val) {
      switch (this.dateType) {
        case "day":
          this.startDate = formatterDate(this.dateDay);
          this.endDate = addDate(this.dateDay);
          break;
        case "month":
          this.startDate = this.dateMonth[0];
          this.endDate = this.dateMonth[1];
          break;
        case "year":
          this.startDate = this.dateYear;
          this.endDate = this.dateYearEnd;
          break;
        default:
          break;
      }

      this.getChartDataEv();
    },
    changeStartYear(val) {
      // 开始年份大于结束年份，调换
      if (Number(this.dateYear) > Number(this.dateYearEnd)) {
        this.dateYear = this.dateYearEnd;
        this.dateYearEnd = val;
      }
      this.changeDateEv();
      // 将改动传回父组件
    },
    changeEndYear(val) {
      if (Number(this.dateYear) > Number(this.dateYearEnd)) {
        this.dateYearEnd = this.dateYear;
        this.dateYear = val;
      }
      this.changeDateEv();
    },
  },
};
</script>

<style lang="scss" scoped>
.leftBox {
  width: 32%;
  max-width: 600px;
  height: 100%;

  .top-card {
    width: 100%;
    height: 224px;
    margin-bottom: 16px;

    ::v-deep .el-card__body {
      width: 100%;
      height: 100%;
      padding: 0;
      box-sizing: border-box;

      .top {
        width: 100%;
        height: 160px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #dce3e1;
        padding-left: 20px;

        .info {
          margin-left: 32px;
          font-size: 14px;

          > div:nth-child(1) {
            margin-bottom: 16px;
          }

          .active {
            color: #8b9996;
            margin-bottom: 3px;
          }
        }
      }

      .bottom-btn {
        width: 100%;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 20px;
        box-sizing: border-box;

        .btn {
          color: #fff;
          background-color: #068d6c;
        }
      }
    }
  }

  .bottom-card {
    width: 100%;
    height: 632px;

    :deep(.el-card__body) {
      width: 100%;
      height: 100%;
      padding: 0;
      box-sizing: border-box;

      .center {
        width: 92%;
        max-width: 552px;
        // height: 280px;
        height: 100%;
        margin: 0 auto;
        padding-top: 30px;
        box-sizing: border-box;
        overflow: hidden;
        // background-color: pink;
        // padding: 40px 24px 40px 24px;
        // border-bottom: 1px solid #dce3e1;

        .word {
          .selectInfo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
          }
        }
      }

      .bottom {
        width: 92%;
        max-width: 552px;
        // height: 327px;
        margin: 0 auto;
        padding-top: 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .word {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .el-table {
          margin-top: 24px;
        }
      }
    }

    .btnGroup {
      width: 122px;
      height: 32px;
      background: #f4f8f7;

      display: flex;
      justify-content: space-around;
      align-items: center;

      .btn {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f4f8f7;
        padding: 0;
        margin: 0;
      }

      .active {
        background-color: #068d6c;
        color: #fff;
      }
    }
  }
}
</style>
